import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { QUERY_ENUM } from '@services/routeList';
import { MODAL_NAME } from '@features/ui-layout/templates/ModalContainer';
import { selectLastModalOpen } from '@features/ui-layout/slices/uiLayoutSlice';

export const isModalClosed = (exclude?: Array<MODAL_NAME>) => {
  const router = useRouter();
  const lastModalOpen = useSelector(selectLastModalOpen);
  const [isModalClosed, setIsModalClosed] = useState(true);

  const lastIsOneToExclude = exclude?.some(modalName => lastModalOpen === modalName) ?? false;

  useEffect(() => {
    const modalQuery = router.query[QUERY_ENUM.modal];
    setIsModalClosed(modalQuery == null);
  }, [router.query]);

  return isModalClosed && !lastIsOneToExclude;
};
